import { render, staticRenderFns } from "./LexinKeyboardLangFil.vue?vue&type=template&id=3383e18a&"
import script from "./LexinKeyboardLangFil.vue?vue&type=script&lang=js&"
export * from "./LexinKeyboardLangFil.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports